import { render, staticRenderFns } from "./salesFeeRegisterAction.vue?vue&type=template&id=48dec28e&scoped=true"
import script from "./salesFeeRegisterAction.vue?vue&type=script&lang=js"
export * from "./salesFeeRegisterAction.vue?vue&type=script&lang=js"
import style0 from "./salesFeeRegisterAction.vue?vue&type=style&index=0&id=48dec28e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dec28e",
  null
  
)

export default component.exports